<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-4">
              <v-text-field
                label="Cliente"
                v-model="current.contractClientName"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-4">
              <v-text-field
                label="E-mail"
                v-model="current.contractClientEmail"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-text-field
                label="Nascimento"
                :value="current.contractClientBirth | formatDate"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-text-field
                label="Idade"
                :value="current.contractClientBirth | calcAge"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col-9">
              <v-text-field
                label="Endereco"
                v-model="current.contractAddress"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-3">
              <v-text-field
                label="Cidade"
                v-model="current.contractCity"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <v-text-field
                label="Plano"
                v-model="current.contractPlanName"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-text-field
                label="Instalacao"
                :value="current.contractSetup | formatDate"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-text-field
                label="Valor"
                v-model="current.contractPayValue"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-text-field
                label="Vencimento"
                v-model="current.contractPayDay"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-chip :color="colorContractStatus(current.contractStatus)">{{current.contractStatus | formatContractStatus}}</v-chip>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <v-text-field
                label="Tipo de Contato"
                v-model="current.typeName"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-3">
              <v-text-field
                label="Telefone"
                v-model="current.contractClientTelephone"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-3">
              <v-text-field
                label="Celular"
                v-model="current.contractClientCellphone"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-3">
              <v-select
                label="Status"
                v-model="current.status"
                :items="status"
                outlined
                dense
                disabled
              ></v-select>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <v-alert dense text color="default" icon="mdi-alert-box" v-if="current.request">
                {{ current.request }}
              </v-alert>
              <div class="d-flex align-center mb-4">
                <v-subheader class="pl-0">Canal</v-subheader>
                <v-btn-toggle v-model="current.channel" dense>
                  <v-btn :value="1" title="Telefone" :disabled="current.status == 2">
                    <v-icon left>mdi-phone</v-icon> telefone
                  </v-btn>
                  <v-btn :value="2" title="WhatsApp" :disabled="current.status == 2">
                    <v-icon left>mdi-whatsapp</v-icon> whatsapp
                  </v-btn>
                </v-btn-toggle>
              </div>
              <v-textarea
                rows="12"
                label="Resposta"
                v-model="current.response"
                outlined
                dense
                :disabled="current.status == 2"
              ></v-textarea>
              <v-btn color="default" @click="abrirFaturas()" class="mr-2">
                <v-icon title="faturas" left>mdi-barcode</v-icon> faturas
              </v-btn>
              <v-btn color="default" @click="abrirAdicional()">
                <v-icon title="faturas" left>mdi-phone-forward</v-icon> contato
                adicional
              </v-btn>
            </div>
            <div class="col-6">
              <v-alert dense text color="default" icon="mdi-arrow-down">
                Contatos anteriores
              </v-alert>
              <v-alert
                v-for="item in dones"
                :key="item.id"
                dense
                text
                :color="scoreColor(item.score)"
                :icon="scoreIcon(item.score)"
              >
                <div>
                  {{ item.typeName }}
                  <v-icon v-if="channelIcon(item.channel)" small :title="item.channel | formatChannel">{{ channelIcon(item.channel) }}</v-icon>
                  - {{ item.done | formatDate }}
                </div>
                <div>{{ item.response | formatResponse }}</div>
              </v-alert>
            </div>
          </div>

          <div class="row">
            <v-col cols="6">
              <v-subheader class="pl-0">Probabilidade de indicar?</v-subheader>
              <v-slider
                class="mt-8"
                v-model="current.score"
                thumb-label="always"
                max="10"
                :readonly="current.status == 2 ? true : false"
              ></v-slider>
            </v-col>
            <v-col cols="6">
              <v-subheader class="pl-0">Índice de Humanização</v-subheader>
              <v-slider
                class="mt-8"
                v-model="current.scoreh"
                thumb-label="always"
                max="10"
                :readonly="current.status == 2 ? true : false"
              ></v-slider>
            </v-col>
          </div>

        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn color="secondary" @click="back()">
          <v-icon title="Voltar" left>mdi-arrow-left</v-icon> voltar
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn color="primary" v-if="current.status != 2" @click="save(1)">
          <v-icon title="Agendada" left>mdi-phone</v-icon> agendada
        </v-btn>
        <v-btn color="success" v-if="current.status != 2" @click="save(2)">
          <v-icon title="Atendida" left>mdi-phone-in-talk</v-icon> atendida
        </v-btn>
        <v-btn color="warning" v-if="current.status != 2" @click="save(3)">
          <v-icon title="Nao atendida" left>mdi-phone-missed</v-icon> nao
          atendida
        </v-btn>
        <v-btn color="error" v-if="current.status != 2" @click="save(4)">
          <v-icon title="Nao existe" left>mdi-phone-off</v-icon> nao existe
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="dialog_faturas"
      max-width="600"
      @click:outside="fecharFaturas()"
    >
      <v-card v-if="current">
        <v-card-title class="headline">Faturas</v-card-title>
        <v-card-text>
          <v-text-field
            label="Cliente"
            v-model="current.contractClientName"
            outlined
            dense
            readonly
          ></v-text-field>
          <div v-if="loading_faturas" class="text-center py-8">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <v-simple-table v-else-if="faturas">
            <thead>
              <tr>
                <th>Documento</th>
                <th>Vencimento</th>
                <th>Valor</th>
                <th>Status</th>
                <th>Acoes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in faturas" :key="item.id">
                <td>{{ item.documento }}</td>
                <td>{{ item.vencimento | formatDate }}</td>
                <td>R$ {{ item.valor | formatMoney }}</td>
                <td>
                  <v-btn x-small v-bind:color="colorFaturaStatus(item.status)">{{
                    item.status | formatFaturaStatus
                  }}</v-btn>
                </td>
                <td>
                  <v-btn
                    small
                    color="warning"
                    @click="visualizarFatura(item.boleto)"
                    >2 via</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secundary" @click="fecharFaturas()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_adicional"
      max-width="600"
      @click:outside="fecharAdicional()"
    >
      <v-card v-if="current">
        <v-card-title class="headline">Contato adicional</v-card-title>
        <v-card-text>
          <v-text-field
            label="Cliente"
            v-model="current.contractClientName"
            outlined
            dense
            readonly
          ></v-text-field>
          <v-select
            v-model="tipoSelecionado"
            label="Tipo de Contato"
            :items="tipos"
            item-text="name"
            item-value="id"
            outlined
            dense
          ></v-select>
          <v-menu
            v-model="menu_dia"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDia"
                label="Dia"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dia"
              @input="diaAlterada()"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
          <v-textarea
                rows="6"
                label="Comentário"
                v-model="requestRecon"
                outlined
                dense
              ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secundary" @click="fecharAdicional()">Fechar</v-btn>
          <v-btn color="success" @click="criarAdicional()"
            >Criar contato adicional</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: function () {
    return {
      current: null,
      faturas: null,
      dialog_faturas: false,
      loading_faturas: false,
      dialog_adicional: false,
      status: [
        { text: "Agendada", value: 1 },
        { text: "Atendida", value: 2 },
        { text: "Não atendida", value: 3 },
        { text: "Não existe", value: 4 },
      ],
      dones: [],
      tipos: [],
      tipoSelecionado: 0,
      menu_dia: false,
      dia: null,
      requestRecon: '',
    };
  },
  created: function () {
    this.load();
    this.loadTipos();
  },
  methods: {
    loadOld: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contact/contract/" + me.current.contractId, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].done) {
              me.dones.push(response.data[i]);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contact/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
          if (me.current.channel === undefined) {
            me.$set(me.current, "channel", null);
          }
          me.loadOld();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadTipos: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contact_type", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.tipos = response.data;
        })
        .catch(function () {
          console.log("contact_type fail");
        });
    },
    back: function () {
      this.$router.go(-1);
    },
    save: function (status) {
      if (status == 2 && !this.current.channel) {
        alert("Informe o canal do contato: telefone ou WhatsApp.");
        return;
      }
      this.current.status = status;
      var token = localStorage.getItem("token");
      var data = {
        status: status,
        score: this.current.score,
        scoreh: this.current.scoreh,
        response: this.current.response,
        channel: this.current.channel || null
      };
      api
        .put("/contact/done/"+this.current.id, data, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          alert("Contato salvo com sucesso!");
          router.push({ path: "/contact/" });
        })
        .catch(function () {
          console.log("contact done fail");
          alert("Erro ao salvar contato!");
        });
    },
    channelIcon: function (channel) {
      var icon = null;
      if (channel == 1) {
        icon = "mdi-phone";
      } else if (channel == 2) {
        icon = "mdi-whatsapp";
      }
      return icon;
    },
    scoreIcon: function (score) {
      return "mdi-numeric-" + score + "-box";
    },
    scoreColor: function (score) {
      var ret = "default";
      if (score < 7) {
        ret = "error";
      } else if (score < 9) {
        ret = "warning";
      } else {
        ret = "success";
      }
      return ret;
    },
    abrirFaturas: function () {
      var me = this;
      var token = localStorage.getItem("token");
      this.faturas = null;
      this.loading_faturas = true;
      this.dialog_faturas = true;
      api
        .get("/duplicata/client/" + this.current.contractClientId, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.faturas = response.data;
          me.loading_faturas = false;
        })
        .catch(function () {
          console.log("duplicata fail");
          me.loading_faturas = false;
          alert("Erro ao carregar faturas!");
        });
    },
    abrirAdicional: function () {
      this.dialog_adicional = true;
    },
    fecharFaturas: function () {
      this.dialog_faturas = false;
    },
    fecharAdicional: function () {
      this.dialog_adicional = false;
    },
    visualizarFatura: function (boleto) {
      if (boleto) {
        window.open(boleto, "_blank");
      } else {
        alert("Boleto indisponivel!");
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    diaAlterada: function () {
      this.menu_dia = false;
    },
    criarAdicional: function () {
      var me = this;
      var token = localStorage.getItem("token");
      var dados = { expires: this.dia, typeId: this.tipoSelecionado, request: this.requestRecon };
      api
        .post("/contact/recontact/" + this.current.id, dados, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          alert("Novo contato salvo com sucesso!");
          me.dialog_adicional = false;
        })
        .catch(function () {
          console.log("contact novo fail");
          alert("Erro ao salvar novo contato!");
        });
    },
    colorFaturaStatus: function (status) {
      var color = "default";
      if (status == 1) {
        color = "primary";
      } else if (status == 2) {
        color = "success";
      } else if (status == 3) {
        color = "warning";
      }
      return color;
    },
    colorContractStatus: function(status){
      var color = "default";
      if(status==0){
        color = "success";
      } else if (status == 1) {
        color = "warning";
      } else if (status == 2) {
        color = "info";
      } else if (status == 3) {
        color = "error";
      } else if (status == 4) {
        color = "secondary";
      }
      return color;
    }
  },
  filters: {
    formatResponse: function (response) {
      return response;
    },
    formatChannel: function (channel) {
      var text = "";
      if (channel == 1) {
        text = "Telefone";
      } else if (channel == 2) {
        text = "WhatsApp";
      }
      return text;
    },
    formatFaturaStatus: function (status) {
      var text = "desconhecido";
      if (status == 1) {
        text = "Aberto";
      } else if (status == 2) {
        text = "Pago";
      } else if (status == 3) {
        text = "Negociado";
      }
      return text;
    },
    formatContractStatus: function (status) {
      var text = "Desconhecido";
      if (status==0){
        text = "Habilitado";
      }else if (status==1){
        text = "Bloqueio administrador";
      }else if(status==2){
        text = "Bloqueio cliente";
      }else if(status==3){
        text = "Bloqueio financeiro";
      }else if(status==4){
        text = "Cancelado";
      }
      return text;
    }
  },
  computed: {
    computedDia() {
      return this.formatDate(this.dia);
    },
  },
};
</script>